import {Component, OnInit} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {WoType} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-wo-type-list',
  templateUrl: './wo-type-list.component.html',
  standalone: false,
})
export class WoTypeListComponent implements OnInit {

  rows: WoType[] = [];
  isLoaded = false;
  editingRow: Partial<WoType> | null = null;
  isNew = false;

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.woService.getWoTypes().subscribe({
      next: (r) => {
        this.rows = r;
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  startNew(): void {
    this.editingRow = {
      name: '',
      default_billing_rate: null,
      default_sla_response_hours: null,
      default_sla_resolution_hours: null,
      active: true,
      sort_order: 0
    };
    this.isNew = true;
  }

  startEdit(row: WoType): void {
    this.editingRow = {...row};
    this.isNew = false;
  }

  cancelEdit(): void {
    this.editingRow = null;
  }

  save(): void {
    if (!this.editingRow?.name) {
      return;
    }
    const obs = this.isNew
      ? this.woService.createWoType(this.editingRow)
      : this.woService.updateWoType((this.editingRow as WoType).id, this.editingRow);
    obs.subscribe({
      next: () => {
        this.notification.showSuccessToast('Saved.');
        this.editingRow = null;
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving.');
      }
    });
  }

  delete(id: string): void {
    this.confirmDialog.confirmThis(['Delete this WO type?'],
      () => {
        this.woService.deleteWoType(id).subscribe({
          next: () => {
            this.notification.showSuccessToast('Deleted.');
            this.load();
          },
          error: () => {
            this.notification.showErrorToast('Error deleting.');
          }
        });
      }, () => {
      });
  }
}
